import React from "react";

// undocumented hack to trigger `onNavigation` for an IndexRow
// https://github.com/Shopify/polaris-react/blob/197f9fb81874daeb025672979a92455608e202f5/src/components/IndexTable/components/Row/tests/Row.test.tsx#L178
export const IndexTableRowPrimaryLink: React.FC = ({ children }) => {
  return <a data-primary-link>{children}</a>;
};
